import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Pages.css";

const ProductsIndustries = () => {
  const products = [
    {
      title: "Data Intelligence Tools",
      items: [
        "High-quality business and customer data",
        "Targeted lists for lead generation",
        "Insights for smarter decision-making",
      ],
    },
    {
      title: "Marketing & Growth Tools",
      items: [
        "Email marketing campaigns",
        "Social media and digital marketing solutions",
        "Lead generation and nurturing systems",
      ],
    },
    {
      title: "Custom Solutions & Tech Products",
      items: [
        "Tailored software for your business needs",
        "Industry-specific platforms and tools",
        "Integration with existing systems",
      ],
    },
  ];

  const industries = [
    {
      title: "Technology Companies",
      description:
        "AI, data, and automation solutions for tech-focused businesses. Insights for product and business optimization.",
    },
    {
      title: "Healthcare & Professional Services",
      description:
        "Targeted data and marketing solutions. Compliance-aware strategies for sensitive industries.",
    },
    {
      title: "Marketing & Sales Teams",
      description:
        "Lead generation, CRM integration, and campaign optimization. Data-driven decision-making tools.",
    },
  ];

  return (
    <main>
      <Helmet>
        <title>Products &amp; Industries | Seagull Partners</title>
        <meta
          name="description"
          content="See the products and industries Seagull Partners supports, with tailored B2B data, marketing, and growth solutions for your market and goals—with confidence."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Products & Industries We Serve</h1>
          <p className="page-hero-subtitle">
            Seagull delivers{" "}
            <strong>custom, data-driven products and solutions</strong>
            tailored to the unique needs of different industries. Explore how we
            can help your business grow.
          </p>
          <Link to="/contact" className="btn">
            📩 Get a Custom Solution
          </Link>
        </div>
      </section>

      {/* Products Section */}
      <section className="section products-section">
        <div className="container">
          <div className="content-section">
            <h2 className="section-title">Our Products</h2>
            <p className="section-intro">
              Seagull offers a range of{" "}
              <strong>smart tools and services</strong> designed to optimize
              growth and improve business performance.
            </p>

            <div className="products-grid">
              {products.map((product, index) => (
                <div key={index} className="product-card">
                  <div className="product-header">
                    <span className="product-icon">🔹</span>
                    <h3>
                      {index + 1}. {product.title}
                    </h3>
                  </div>
                  <ul className="product-items">
                    {product.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="products-cta">
              <Link to="/contact" className="btn">
                ➡ Explore All Products
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="section industries-full-section">
        <div className="container">
          <div className="content-section">
            <h2 className="section-title">Industries We Serve</h2>
            <p className="section-intro">
              Seagull has experience across multiple industries, delivering
              <strong>
                {" "}
                customized solutions that drive measurable results
              </strong>
              .
            </p>

            <div className="industries-grid">
              {industries.map((industry, index) => (
                <div key={index} className="industry-card-full">
                  <div className="industry-icon">🔹</div>
                  <h3>{industry.title}</h3>
                  <p>{industry.description}</p>
                </div>
              ))}
            </div>

            <div className="industries-cta">
              <Link to="/contact" className="btn">
                📩 Contact Us to See How We Can Help
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProductsIndustries;
